<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>
<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/event.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-3">
                  <div class="pagename">
                    <h3 class="card-title">Upcoming Event</h3>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ eventList.length }}</h2>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="addbtn">
                    <button
                      id="add_btn"
                      type="button"
                      class="btn btn-primary addbtn"
                      (click)="open(content)"
                      style="float: right"
                    >
                      Add Event
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                style="white-space: nowrap"
                datatable
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th style="width: 3%">#Sl</th>
                    <th style="width: 20%">Name</th>
                    <th>Event Type</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th style="width: 5%">Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let item of eventList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.event_type }}</td>
                    <td>{{ item.from_date }}</td>
                    <td>{{ item.to_date }}</td>
                    <td>
                      <span *ngIf="item.created_by_name == 'admin'"
                        >WEP-Admin</span
                      >
                      <span *ngIf="item.created_by_name != 'admin'">{{
                        item.created_by_name
                      }}</span>
                    </td>
                    <td>{{ item.created_at }}</td>
                    <td>
                      <span
                        *ngIf="item.is_active == 'Y'"
                        class="badge badge-success badge-pill"
                        >Active</span
                      >
                      <span
                        *ngIf="item.is_active == 'N'"
                        class="badge badge-danger badge-pill"
                        >Inactive</span
                      >
                    </td>
                    <td class="action position-relative">
                      <label class="switch">
                        <input
                          type="checkbox"
                          (change)="delete(item)"
                          [checked]="item.is_active === 'Y'"
                        />
                        <span class="slider round"></span>
                      </label>
                      <button
                        type="button"
                        class="btn text-dark btn-sm rounded bg-light"
                        (click)="edit(this.eventList[i].id, content)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <button
                        class="ml-1 btn text-dark btn-sm rounded bg-light custom-tooltip-trigger"
                        (click)="upload(this.eventList[i].id, media)"
                      >
                        <i class="fa fa-upload"></i>
                      </button>

                      <span class="custom-tooltip">Upload media</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #content let-c="close" let-d="dismiss" id="customer-add">
      <!-- class="modal fade" -->
      <div class="modal-info" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modalTitle }}</h4>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <alert>
              <div class="alert alert-danger"><a class="close">×</a></div>
            </alert>
            <form
              method="post"
              enctype="multipart/form-data"
              class="form-horizontal"
              #f="ngForm"
            >
              <div class="row">
                <div class="form-group col-md-12">
                  <label for="name" class="col-form-label"
                    >Name <span>*</span></label
                  >
                  <div class="  ">
                    <input
                      class="form-control"
                      type="text"
                      id="name"
                      name="name"
                      required
                      [(ngModel)]="event.name"
                    />
                    <span
                      *ngIf="isSubmitted && isFieldsInvalid(event.name)"
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="form-group col-md-12">
                  <label for="about" class="col-form-label"
                    >About <span>*</span></label
                  >
                  <div class="  ">
                    <angular-editor
                      [config]="configbody"
                      required
                      id="about"
                      [(ngModel)]="event.about"
                      name="about"
                    >
                    </angular-editor>

                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.about == undefined || event.about == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="from_date" class="col-form-label"
                    >From Date <span>*</span></label
                  >
                  <div class="  ">
                    <input
                      class="form-control"
                      type="datetime-local"
                      id="from_date"
                      name="from_date"
                      required
                      [(ngModel)]="event.from_date"
                    />
                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.from_date == undefined || event.from_date == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="to_date" class="col-form-label"
                    >To Date <span>*</span></label
                  >
                  <div class="  ">
                    <input
                      class="form-control"
                      type="datetime-local"
                      id="to_date"
                      name="to_date"
                      required
                      [(ngModel)]="event.to_date"
                    />
                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.to_date == undefined || event.to_date == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="form-control-label"
                      >Image <span>*</span></label
                    >

                    <div class="">
                      <img
                        style="height: 100px; width: 100px; padding: 0"
                        class="img-thumbnail mb-3"
                        *ngIf="croppedImage != ''"
                        [src]="croppedImage"
                      />
                      <div class="input-group">
                        <span class="input-group-btn">
                          <label class="btn btn-dark">
                            <samp>Browse</samp>...
                            <input
                              type="file"
                              accept="{{ fileType }}"
                              style="display: none"
                              (change)="onFileChange($event)"
                              [attr.multiple]="allowMultiple"
                            />
                          </label>
                        </span>
                        <input
                          type="text"
                          class="form-control"
                          [value]="DisplayedText"
                          disabled=""
                          [class.ng-invalid-right]="required && !DisplayedText"
                          [class.ng-valid-right]="required && DisplayedText"
                          style="height: 35px; border-radius: 0px"
                        />
                      </div>

                      <ng-template
                        #contentCrop
                        let-c="close"
                        let-d="dismiss"
                        id="image_cropper"
                      >
                        <div class="modal-content">
                          <h3 class="text-center mt-2">Image Cropper</h3>
                        </div>
                      </ng-template>
                      <span
                        *ngIf="
                          isSubmitted &&
                          (event.image == undefined || event.image == '')
                        "
                        class="alert-block"
                        >This field is required</span
                      >
                    </div>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="event_type" class="col-form-label"
                    >Event Type <span>*</span></label
                  >
                  <div class="">
                    <select
                      class="form-control"
                      id="event_type"
                      name="event_type"
                      required
                      [(ngModel)]="event.event_type"
                    >
                      <option value="online">online</option>
                      <option value="offline">offline</option>
                    </select>
                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.event_type == undefined ||
                          event.event_type == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="form-group col-md-6 align-self-end">
                  <label for="event_state" class="form-control-label"
                    >State
                  </label>
                  <div class="  ">
                    <select
                      class="form-control"
                      id="event_state"
                      name="event_state"
                      [(ngModel)]="event.event_state"
                      (ngModelChange)="selectCityById($event)"
                    >
                      <option value="" selected disabled>Please Select</option>
                      <option *ngFor="let item of states" value="{{ item.id }}">
                        {{ item.state_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="event_city" class="form-control-label"
                    >City
                  </label>
                  <div class="">
                    <select
                      class="form-control"
                      id="event_city"
                      name="event_city"
                      [(ngModel)]="event.event_city"
                    >
                      <option value="" selected>Please Select</option>
                      <option *ngFor="let item of cities" value="{{ item.id }}">
                        {{ item.city_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="event_vertical" class="form-control-label"
                    >Category<span>*</span></label
                  >
                  <div class="  ">
                    <select
                      class="form-control"
                      id="event_vertical"
                      name="event_vertical"
                      [(ngModel)]="event.event_vertical"
                      required
                    >
                      <option value="" selected disabled>Please Select</option>
                      <option *ngFor="let item of cat" value="{{ item.id }}">
                        {{ item.name }}
                      </option>
                    </select>
                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.event_vertical == undefined ||
                          event.event_vertical == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="sectorofenterprise" class="form-control-label"
                      >Sector of Enterprise<span>*</span></label
                    >
                    <div class="">
                      <ng-select
                        [items]="sectorofenterprise"
                        name="sectorofenterprise"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="id"
                        [(ngModel)]="selectedToEnterprise"
                        (change)="changeToEnterprise()"
                        required
                      >
                      </ng-select>
                      <span
                        *ngIf="
                          isSubmitted &&
                          (event.sectorofenterprise == undefined ||
                            event.sectorofenterprise == '')
                        "
                        class="alert-block"
                        >This field is required</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="areaofinterest" class="form-control-label"
                      >Area of Interest</label
                    >
                    <div class="">
                      <ng-select
                        [items]="areaofinterest"
                        name="areaofinterest"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="id"
                        [(ngModel)]="selectedToInterest"
                        (change)="changeToInterest()"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="areaofstudy" class="form-control-label"
                      >Area of Study</label
                    >
                    <div class="">
                      <ng-select
                        [items]="areaofstudy"
                        name="areaofstudy"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="id"
                        [(ngModel)]="selectedToStudy"
                        (change)="changeToStudy()"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-12">
                  <label for="event_address" class="col-form-label"
                    >Event Address</label
                  >
                  <div class="">
                    <textarea
                      class="form-control"
                      type="text"
                      id="event_address"
                      name="event_address"
                      [(ngModel)]="event.event_address"
                    ></textarea>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="oraganised_by" class="col-form-label"
                    >Organised By<span>*</span></label
                  >
                  <div class="  ">
                    <input
                      class="form-control"
                      type="text"
                      id="oraganised_by"
                      name="oraganised_by"
                      required
                      [(ngModel)]="event.oraganised_by"
                    />
                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.oraganised_by == undefined ||
                          event.oraganised_by == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="event_language" class="col-form-label"
                    >Event Language<span>*</span></label
                  >
                  <div class="  ">
                    <input
                      class="form-control"
                      type="text"
                      id="event_language"
                      name="event_language"
                      required
                      [(ngModel)]="event.event_language"
                    />
                    <span
                      *ngIf="
                        isSubmitted &&
                        (event.event_language == undefined ||
                          event.event_language == '')
                      "
                      class="alert-block"
                      >This field is required</span
                    >
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="who_is_relevant_for" class="col-form-label"
                    >Who Is Relevant For</label
                  >
                  <div class="  ">
                    <input
                      class="form-control"
                      type="text"
                      id="who_is_relevant_for"
                      name="who_is_relevant_for"
                      [(ngModel)]="event.who_is_relevant_for"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="associate_partners" class="form-control-label"
                      >Associate Partners</label
                    >
                    <div class="">
                      <ng-select
                        [items]="associatepartners"
                        name="associate_partners"
                        [multiple]="true"
                        bindLabel="name"
                        bindValue="id"
                        [(ngModel)]="selectedToPartners"
                        (change)="changeToPartners()"
                      >
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-12">
                  <label for="registration_details_link" class="col-form-label"
                    >Registration Details Link
                  </label>
                  <div class="">
                    <textarea
                      class="form-control"
                      type="text"
                      id="registration_details_link"
                      name="registration_details_link"
                      [(ngModel)]="event.registration_details_link"
                    ></textarea>
                  </div>
                </div>
                <div class="form-group col-md-12">
                  <label for="keywords" class="col-form-label">Keywords </label>
                  <div class="">
                    <textarea
                      class="form-control"
                      type="text"
                      id="keywords"
                      name="keywords"
                      [(ngModel)]="event.keywords"
                    ></textarea>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label for="home_display" class="col-form-label"
                    >Home Display</label
                  >
                  <div class="  ">
                    <select
                      class="form-control"
                      id="home_display"
                      name="home_display"
                      [(ngModel)]="event.home_display"
                    >
                      <option value="N">No</option>
                      <option value="Y">Yes</option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label for="is_active" class="col-form-label">Status</label>
                  <div class="  ">
                    <select
                      class="form-control"
                      id="is_active"
                      name="is_active"
                      [(ngModel)]="event.is_active"
                    >
                      <option value="N">Inactive</option>
                      <option value="Y">Active</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6 mt-2">
                  <p style="margin-bottom: 0">Event Owner</p>
                  <small style="margin-right: 2px">Other Events </small>
                  <label class="switch">
                    <input
                      type="checkbox"
                      (click)="onClickEventChange()"
                      [checked]="event_owner === 'wep'"
                    />
                    <span class="slider round"></span>&nbsp;
                  </label>
                  <small>WEP Events</small>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary d-none"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              Close
            </button>

            <!-- <button type="submit" class="btn btn-primary rounded savebtn" (click)="save(this.event,f)">Save</button> -->
            <button
              type="submit"
              class="btn btn-primary rounded savebtn"
              (click)="save(this.event, f)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #media let-c="close" let-d="dismiss" id="uploadmedia">
      <div class="modal-info" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">{{ modalTitle }}</h4>
            <button
              type="button"
              class="close"
              aria-label="Close"
              (click)="d('Cross click')"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <form
            #f="ngForm"
            class="form-horizontal"
            enctype="multipart/form-data"
          >
            <div class="modal-body">
              <!-- Error Alerts -->
              <div
                class="alert alert-danger event_alert"
                *ngIf="formError || imageError || videoError || urlThumbError"
              >
                <small class="text-danger">
                  {{ formError || imageError || videoError || urlThumbError }}
                </small>
              </div>

              <!-- Upload Images Section -->
              <div class="row">
                <div class="col-md-12">
                  <div class="row align-items-end">
                    <div class="col-md-4">
                      <label
                        class="form-label"
                        style="font-size: 18px; font-weight: 600"
                      >
                        Upload Images
                      </label>
                      <div class="input-group">
                        <span class="input-group-btn">
                          <label class="btn btn-dark">
                            <samp>Browse</samp>...
                            <input
                              type="file"
                              style="display: none"
                              accept="{{ fileType }}"
                              (change)="fileChangeImage($event)"
                              [attr.multiple]="allowMultipleImage ? '' : null"
                            />
                          </label>
                        </span>
                        <input
                          type="text"
                          class="form-control"
                          [value]="
                            previewImages.length > 0
                              ? previewImages.length + ' image(s) selected'
                              : ''
                          "
                          disabled
                          style="height: 35px; border-radius: 0"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- New Image Previews -->
                  <div
                    class="d-flex flex-wrap flex-row mt-3"
                    *ngIf="previewImages?.length > 0"
                  >
                    <div
                      class="position-relative"
                      style="width: 9%; margin-right: 12px; margin-bottom: 10px"
                      *ngFor="let img of previewImages; let i = index"
                    >
                      <button
                        type="button"
                        class="btn btn-danger btn-sm rounded-circle position-absolute p-0"
                        style="
                          top: -8px;
                          right: -7px;
                          z-index: 10;
                          width: 20px;
                          height: 20px;
                        "
                        (click)="removePreviewImage(i)"
                        title="Remove"
                      >
                        ×
                      </button>
                      <img
                        [src]="img"
                        class="img-fluid rounded shadow-sm border w-100"
                        alt="Preview"
                        style="height: 100%; object-fit: contain"
                      />
                    </div>
                  </div>

                  <!-- Existing Images from Server -->
                  <div class="mt-4" *ngIf="eventMediaListImage.length > 0">
                    <div class="d-flex flex-wrap flex-row">
                      <div
                        class="position-relative"
                        style="
                          width: 9%;
                          margin-right: 12px;
                          margin-bottom: 10px;
                        "
                        *ngFor="let media of eventMediaListImage"
                      >
                        <button
                          type="button"
                          class="btn btn-danger btn-sm rounded-circle position-absolute p-0"
                          style="
                            top: -8px;
                            right: -8px;
                            z-index: 10;
                            width: 20px;
                            height: 20px;
                            font-size: smaller;
                            padding: 0;
                          "
                          (click)="removeEventMedia(media.id, 'image')"
                          title="Delete"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <img
                          [src]="media.image"
                          class="img-fluid rounded shadow-sm border w-100"
                          style="height: 100%; object-fit: contain"
                          alt="Event image"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr style="margin: 30px 0" />

              <!-- Upload Videos Section -->
              <div class="row">
                <div class="col-md-12">
                  <div class="row align-items-end">
                    <div class="col-md-4">
                      <label
                        class="form-label"
                        style="font-size: 18px; font-weight: 600"
                      >
                        Upload Videos
                      </label>
                      <div class="input-group">
                        <span class="input-group-btn">
                          <label class="btn btn-dark">
                            <samp>Browse</samp>...
                            <input
                              type="file"
                              style="display: none"
                              accept="{{ fileTypeVideo }}"
                              (change)="fileChangeVideo($event)"
                              [attr.multiple]="allowMultipleVideo ? '' : null"
                            />
                          </label>
                        </span>
                        <input
                          type="text"
                          class="form-control"
                          [value]="
                            previewVideos.length > 0
                              ? previewVideos.length + ' image(s) selected'
                              : ''
                          "
                          disabled
                          style="height: 35px; border-radius: 0"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- New Video Previews with Thumbnail Upload -->
                  <div class="row gy-4 mt-3" *ngIf="previewVideos?.length > 0">
                    <div
                      class="col-md-3"
                      *ngFor="let video of previewVideos; let i = index"
                    >
                      <div
                        class="card border shadow-sm h-100 position-relative"
                      >
                        <button
                          type="button"
                          class="btn btn-danger btn-sm rounded-circle position-absolute"
                          style="
                            top: -10px;
                            right: -10px;
                            z-index: 10;
                            width: 25px;
                            height: 25px;
                            padding: 0;
                            font-size: medium;
                          "
                          (click)="removePreviewVideo(i)"
                        >
                          ×
                        </button>

                        <video
                          [src]="video.video"
                          controls
                          class="card-img-top"
                          style="object-fit: cover"
                        ></video>

                        <div class="card-body p-3">
                          <label class="form-label small fw-bold">
                            Thumbnail <span class="text-danger">*</span>
                          </label>
                          <input
                            type="file"
                            accept="{{ fileType }}"
                            (change)="fileChangeVideoThumbnail($event, i)"
                            class="form-control form-control-sm"
                          />

                          <div
                            class="text-center mt-2"
                            *ngIf="hasThumbnail(video)"
                          >
                            <img
                              [src]="video.thumbnail"
                              class="img-fluid w-50"
                              alt="Thumbnail"
                            />
                          </div>

                          <small
                            class="text-danger d-block mt-1"
                            *ngIf="!hasThumbnail(video)"
                          >
                            Thumbnail is required!
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Existing Videos from Server -->
                  <div class="mt-4" *ngIf="event_videos.length > 0">
                    <div class="row gy-4">
                      <div class="col-md-3" *ngFor="let vid of event_videos">
                        <div
                          class="card border shadow-sm h-100 position-relative"
                        >
                          <button
                            type="button"
                            class="btn btn-danger btn-sm rounded-circle position-absolute"
                            style="
                              top: -10px;
                              right: -10px;
                              z-index: 10;
                              width: 25px;
                              height: 25px;
                              padding: 0;
                            "
                            (click)="removeEventMedia(vid.id, 'video')"
                          >
                            <i class="fa fa-trash"></i>
                          </button>

                          <video
                            [src]="vid.video"
                            controls
                            class="card-img-top"
                            style="object-fit: cover"
                          ></video>

                          <div
                            class="card-body text-center p-2 d-flex align-items-center justify-content-center position-relative"
                          >
                            <img
                              [src]="vid.thumbnail"
                              class="img-fluid w-50"
                              alt="Thumbnail"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr style="margin: 30px 0" />

              <div class="row">
                <div class="col-md-12">
                  <div
                    class="d-flex justify-content-between align-items-center mb-3"
                  >
                    <label style="font-size: 18px; font-weight: 600">
                      Event URLs (YouTube Links)
                    </label>
                  </div>
                  <div
                    class="row align-items-center mb-3"
                    *ngFor="let urlObj of event_urls; let i = index"
                  >
                    <div class="col-md-8">
                      <input
                        type="url"
                        [(ngModel)]="urlObj.url"
                        [name]="'event_url_' + i"
                        class="form-control"
                        placeholder="https://www.youtube.com/watch?v=..."
                        required
                      />
                    </div>

                    <div class="col-md-2">
                      <div class="d-flex">
                        <button
                          type="button"
                          class="btn btn-outline-danger btn-sm"
                          (click)="removeUrlField(i)"
                          *ngIf="event_urls.length > 1"
                        >
                          <i class="fa fa-trash"></i>
                        </button>

                        <button
                          type="button"
                          class="btn btn-outline-dark btn-sm ml-2"
                          (click)="addUrlField()"
                          *ngIf="
                            i === event_urls.length - 1 &&
                            event_urls.length < maxUrls
                          "
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary rounded"
                (click)="c('Close click')"
              >
                Cancel
              </button>
              <button
                type="button"
                class="btn btn-primary rounded savebtn"
                (click)="uploadmedia()"
              >
                Save Media
              </button>
            </div>
          </form>
        </div>
      </div>
    </ng-template>
  </div>
</div>
